import { render, staticRenderFns } from "./CreateReturnRequest.vue?vue&type=template&id=59fad30d"
import script from "./CreateReturnRequest.vue?vue&type=script&lang=js"
export * from "./CreateReturnRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports